export default {"src":"/_next/static/media/simulator.0731ef42.svg","height":130,"width":170,"blurWidth":0,"blurHeight":0};